import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import {
	getCalculationStateColor,
	getCalculationStateTranslationKey,
} from "@msuite/utils/calculations";
import { moment } from "@msuite/utils/date";
import { formatNumber, guardNumber } from "@msuite/utils/numbers";
import { capitalize, guardString } from "@msuite/utils/strings";
import type { Calculation } from "@msuite/utils/types";
import { RowActions } from "./row-actions";
import { Link } from "@msuite/ui/link";

const columnHelper = createColumnHelper<Calculation>();

export const columns = [
	columnHelper.accessor("name", {
		id: "name",
		header: localized("general.name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("total", {
		id: "total_net",
		header: localized("invoices.sum_net"),
		cell: (cell) => formatNumber(cell.getValue(), "currency"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor("total", {
		id: "total_gross",
		header: localized("invoices.sum_gross"),
		cell: (cell) => formatNumber(cell.getValue() * 1.19, "currency"),
		meta: createMeta({
			isNumeric: true,
		}),
	}),

	columnHelper.accessor((row) => row._serviceCalculationItems?.length, {
		id: "services",
		header: localized("organization.data.services"),
		cell: (cell) => guardNumber(cell.getValue()),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor("type", {
		id: "type",
		header: localized("general.type"),
		cell: (cell) => capitalize(cell.getValue()),
	}),
	columnHelper.accessor("_serviceCalculationMeta.projectId", {
		id: "project",
		header: localized("projects.project"),
		cell: (cell) =>
			cell.getValue() ? (
				<Link href={`/projects/${cell.getValue()}`}>
					{guardString(
						cell.row.original._serviceCalculationMeta?.projectName,
						localized("protocols.untitled"),
					)}
				</Link>
			) : (
				guardString(null)
			),
	}),
	columnHelper.accessor("state", {
		id: "state",
		header: localized("general.state"),
		cell: (cell) => (
			<Tag
				color={getCalculationStateColor(cell.getValue())}
				variant="plain"
			>
				{localized(getCalculationStateTranslationKey(cell.getValue()))}
			</Tag>
		),
	}),
	columnHelper.accessor((row) => moment(row.createdAt).longFormat(), {
		header: localized("general_fields.created_at"),
		id: "createdAt",
		cell: (cell) => cell.getValue(),
		sortFn: (a, b) => {
			return moment(b.original.createdAt).diff(moment(a.original.createdAt));
		},
		meta: createMeta({
			isTabular: true,
		}),
	}),
	createRowActions(RowActions),
];
